export default function useFileValidation(file: File) {
  const validFileTypes = [
    'audio/mpeg',
    'audio/wav',
    'audio/x-wav',
    'audio/x-m4a',
    'mpga',
    'mp3',
    'wav',
    'm4a',
  ];
  if (!validFileTypes.includes(file.type)) {
    return false;
  }

  return true;
}
